import SideMenu from '@/containers/side-menu/SideMenu.vue';
import FinancialAccountHistory from '@/pages/financial-account-history/FinancialAccountHistory.vue';

export default {
  path: '/financial-account-history',
  name: 'FinancialAccountHistory',
  components: {
    mainContent: FinancialAccountHistory,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'financial-account-history',
    },
    breadcrumb: {
      title: 'Contas',
      paths: [{ title: 'Histórico' }],
    },
  },
};
